/* @flow */
import Entity from 'lib/Entity';

import { cloneDeep } from 'lodash';
import { ButtonActionTypes } from 'constants/QuickPromotionConstants';

class QuickPromotionAction extends Entity {
  getLabel(): string {
    return this.get('label');
  }

  getActionType(): number {
    return this.get('action');
  }

  getActionData(): string {
    return this.get('action_data');
  }

  parse(response: Object) {
    const action = cloneDeep(response);
    action['action'] = ButtonActionTypes[action['action'].toUpperCase()]
                    || ButtonActionTypes.UNKNOWN;
    return action;
  }
}

export default QuickPromotionAction;



// WEBPACK FOOTER //
// ./src/entities/QuickPromotionAction.js